import React, { useState,useContext } from "react";
import { TextField, MenuItem ,Button} from "@mui/material";
import { ContextData } from "../../../../../context/Context";
import axios from "axios";
import { toast } from "react-toastify";
import baseUrl from "../../../../../BaseURL";





function ParentsInfo({ formData }) {





  const {UserTokens,ReloadBioForms,setReloadBioForms} = useContext(ContextData)
  
       const [formDatas, setFormDatas] = useState({
      
           father_full_name: formData.parentsInfo.father_full_name || "",
           mother_full_name: formData.parentsInfo.mother_full_name || "",
           guardian_valid_mobile: formData.parentsInfo.guardian_valid_mobile ||  "",
      
       });


       const handleChange = (e) => {
        const { name, value } = e.target;
        setFormDatas((prevData) => ({   ...prevData, [name]: value,}));
      };
    
      
       
      // Handle data to server if succeed
 const handleSubmit = (type) => {

  
      if(type === "f"){

        if ( formDatas.father_full_name.trim() ===  "") {
                
            toast.error('Please fill in all required fields.');
              return
          }


      }



      if(type === "m"){

        if ( formDatas.mother_full_name.trim() === "") {
                
          toast.error('Please fill in all required fields.');
            return
        }


      }

     
      

      if(type === "g"){


        if ( formDatas.guardian_valid_mobile.trim() === "") {
                
          toast.error('Please fill in all required fields.');
            return
        }

      }
 
    

    
   

    

    axios.put(`${baseUrl}/auth/parent_update`,{...formDatas, user_token: UserTokens},{
      withCredentials: true,
      headers: {
        'Accept' : 'application/json'
      }}).then(res=>{

        
       if(res.data.status){
        toast.success(res.data.textStatus);
        setReloadBioForms(!ReloadBioForms)
          }
      

      }).catch(err=> {
          if(err){
              
            toast.error(err.message)
            console.log(err)
            return

          }   
      })


 
}






  return (
    <div>
      <TextField
        label="Father's Full Name"
        name="father_full_name"
        value={formDatas.father_full_name}
        onChange={handleChange}
        fullWidth
        margin="dense"
        required
        InputProps={{
          endAdornment: (
            <Button
              variant="outlined"
              color="secondary"
             onClick={()=> handleSubmit("f")}
               
            >
              Save
            </Button>

    )}}
      />

      <TextField
        label="Mother's Full Name"
        name="mother_full_name"
        value={formDatas.mother_full_name}
        onChange={handleChange}
        fullWidth
        margin="dense"
        required
        InputProps={{
          endAdornment: (
            <Button
              variant="outlined"
              color="secondary"
              onClick={()=> handleSubmit("m")}
               
            >
              Save
            </Button>

    )}}
      />

      <TextField
        label="Guardian's Valid Mobile Number"
        name="guardian_valid_mobile"
        value={formDatas.guardian_valid_mobile}
        onChange={handleChange}
        fullWidth
        margin="dense"
        required
        inputProps={{ maxLength:  11, inputMode: "numeric",minLength: 11, pattern: "[0-9]{11}"}}
        InputProps={{
          endAdornment: (
            <Button
              variant="outlined"
              color="secondary"
              onClick={()=> handleSubmit("g")}
               
            >
              Save
            </Button>

    )}}
      />
    </div>
  );
}

export default ParentsInfo;
